const studentsData = [
  {
    id: 1,
    name: "Chaitanya Chavan",
    class: "S.E",
    achievement: "Academic",
    awardDescription: "Winner - General Case Study organized by IIT Kharagpur, MME",
    date: "29 March 2026",
  },
  {
    id: 2,
    name: "Soumil Chawan",
    class: "S.E",
    achievement: "Academic",
    awardDescription: "Winner - General Case Study organized by IIT Kharagpur, MME",
    date: "29 March 2026",
  },
  {
    id: 3,
    name: "Sudiksha Shailesh Sawant, Om Deepak Rane, Sneha S. Jino",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "First Place - Plutonium 2026 organized by Vasantdada Patil Pratishthan's College of Engineering",
    date: "28 March 2026",
  },
  {
    id: 4,
    name: "Om Deepak Rane, Sudiksha Shailesh Sawant, Ishaan Shailendra Sonar, Ridhima Srivastava",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Finalist - Tech-a-thon 2026 organized by Thadomal Shahani Engineering College",
    date: "28 February 2026",
  },
  {
    id: 5,
    name: "Prathamesh Nathaji Mane, Tanvi Wani",
    class: "B.Tech",
    achievement: "Academic",
    awardDescription: "Winners of Technoczar - Power Pitch",
    date: "26 February 2026",
  },
  {
    id: 6,
    name: "Ananya Nigam",
    class: "S.E",
    achievement: "Academic",
    awardDescription: "Winner - Business Case Study (Operations) at SIMSREE",
    date: "21 February 2026",
  },
  {
    id: 7,
    name: "Shreyas Shinde",
    class: "S.E",
    achievement: "Academic",
    awardDescription: "Winner - Business Case Study (Operations) at SIMSREE",
    date: "21 February 2026",
  },
  {
    id: 8,
    name: "Rushika Shah",
    class: "S.E",
    achievement: "Academic",
    awardDescription: "Winner - Business Case Study (Operations) at SIMSREE",
    date: "21 February 2026",
  },
  {
    id: 9,
    name: "Ishaan Ashish Gawde, Bhavik Pradeep Desai, Aditya Gohil, Anuj Santosh Gite, Vedanth Srideep Dhagay",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Second Place - Agri-Tech Hackathon 2026 organized by K. J. Somaiya College of Engineering",
    date: "6 February 2026",
  },
  {
    id: 10,
    name: "Chaitanya Chavan",
    class: "S.E",
    achievement: "Non-Academic",
    awardDescription: "Runner Up - Humour Us (Standup Comedy), IIT Bombay Mood Indigo",
    date: "18 December 2025",
  },
  {
    id: 11,
    name: "Aditya Patil",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Winners of Smart India Hackathon organized by Government of Jammu & Kashmir",
    date: "9 December 2025",
  },
  {
    id: 12,
    name: "Yash Gramopadhye, Sandeep Menon",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Secured finalist (top 5) position in Business Case Study (SME Insurance) competition organized by E-Cell, IIT Bombay & ICICI Lombard",
    date: "26 November 2025",
  },
  {
    id: 13,
    name: "Woodrow Gonsalves, Saiesh Vandkar, Srushti Hallur",
    class: "B.Tech",
    achievement: "Academic",
    awardDescription: "2nd Runner Up in Emerson-NI System Design Contest 2025 organized by Emerson and NI; final round held at IIT Madras",
    date: "13 November 2025",
  },
  {
    id: 14,
    name: "Yash Gramopadhye, Sandeep Menon",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Winners of Business Case Study (Supply Chain Management) competition organized by DoMS, IIT Madras",
    date: "9 November 2025",
  },
  {
    id: 15,
    name: "Akshat Ambastha, Anuj Gite, Aarushi Ghosh, Vidhi Gond",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Finalist - Break The Case '25 organized by BITS Pilani, Hyderabad Campus",
    date: "8 November 2025",
  },
  {
    id: 16,
    name: "Warad Teni, Chetanarupa Jirgale, Yadnyesh Sable",
    class: "B.Tech & S.Y",
    achievement: "Academic",
    awardDescription: "Secured Runner Up position in SYNERGY - Simulation Hackathon in CRESCENDO 2025 organized by Fr. Conceicao Rodrigues College of Engineering",
    date: "12 October 2025",
  },
  {
    id: 17,
    name: "Aditya Nagane, Ameya Joshi",
    class: "B.Tech",
    achievement: "Academic",
    awardDescription: "Winners of SemiX AI PC Workshop Hackathon organized by SemiX IIT Bombay during 3rd Annual SemiX Summit",
    date: "27 September 2025",
  },
  {
    id: 18,
    name: "Achintya Chavan, Soham Gondhalekar, Harsh Chhallani",
    class: "B.Tech",
    achievement: "Academic",
    awardDescription: "Secured position in Top 10 Team of aiVOLUTION 2025 Hackathon organized by Media.net & Ai.tech",
    date: "27 September 2025",
  },
  {
    id: 19,
    name: "Bhavik Pradeep Desai, Abhigyan Jha, Gargi Dhulekar",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Winners of MnAnalyse 2025 - Premier Mergers & Acquisitions Case Competition organized by IIT Guwahati, Assam",
    date: "24 September 2025",
  },
  {
    id: 20,
    name: "Om Deepak Rane, Sudiksha Shailesh Sawant, Ishaan Shailendra Sonar",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Semifinalist of Atomberg's Atomquest 2025 Annual Innovation Challenge organized by Atomberg Innovation Center, Pune",
    date: "22 September 2025",
  },
  {
    id: 21,
    name: "Anushka Chandurkar",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Fetched Silver Honors (top 8%) certificate in International Astronomy and Astrophysics Competition organized by Edu.Harbour Committee, Germany",
    date: "21 September 2025",
  },
  {
    id: 22,
    name: "Ishaan Ashish Gawde, Bhavik Pradeep Desai, Anuraag Rajesh Bagal, Anuj Santosh Gite, Vedanth Srideep Dhagay",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Quarterfinalist of Digital India RISC-V (DIR-V) Grand Challenge 2025 organized by IIT Madras and sponsored by MeitY",
    date: "19 September 2025",
  },
  {
    id: 23,
    name: "Prathamesh Mane",
    class: "B.Tech",
    achievement: "Non-Academic",
    awardDescription: "Winner of AKANKSHA - Slam Poetry and Spoken Contest organized by Dr. BMN College of Home Science, Mumbai",
    date: "19 September 2025",
  },
  {
    id: 24,
    name: "Madhura Anuse, Pranav Sapkale, Ranveer Rathod",
    class: "S.E",
    achievement: "Academic",
    awardDescription: "Finalists (Top 15) - Eu-Reka 2025 organized by IEEE Pune Section",
    date: "30 August 2025",
  },
  {
    id: 25,
    name: "Uday Yeshi, Shweta Shinde, Yuvraj Kshirsagar, Yash Jadhav, Warad Teni, Atharv Kulkarni, Pallav Tokekar",
    class: "B.Tech",
    achievement: "Academic",
    awardDescription: "3rd Runner's Up Best Team Collaboration Award winners of IEEE IFEC (International Future Energy Challenge) 2025 organized by IEEE and sponsored by Chroma Ate. Inc., Taoyuan, Taiwan",
    date: "18 July 2025",
  },
  {
    id: 26,
    name: "Omkar Lokre, Tejas Kamble, Sarthak Kasture",
    class: "B.E",
    achievement: "Academic",
    awardDescription: "Winner of Best Hardware Project Award at S.P.I.T in academic year 2024-25 for project entitled 'Water Trash Collector'",
    date: "24 April 2025",
  },
  {
    id: 27,
    name: "Prathmesh Mane",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Winner of S.P.I.T The Exponential Award for demonstrating exceptional personal and academic growth, perseverance through challenges and an inspiring commitment to continuous self-improvement",
    date: "24 April 2025",
  },
  {
    id: 28,
    name: "Achintya Chavan, Soham Gondhalekar, Vardhan Joshi",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Winner of Prakalp 3.0 organized by Fr. Conceicao Rodrigues Institute of Technology, Mumbai",
    date: "19 April 2025",
  },
  {
    id: 29,
    name: "Achintya Chavan, Harsh Chhallani, Manan Andraskar",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Finalist of Airavat 2.0 hackathon organized by Sardar Patel Institute of Technology, Mumbai",
    date: "13 April 2025",
  },
  {
    id: 30,
    name: "Muhammad Adil Bankar",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Domain (AI for social cause) Winners of Airavat 2.0 hackathon organized by Sardar Patel Institute of Technology, Mumbai",
    date: "13 April 2025",
  },
  {
    id: 31,
    name: "Sudhanshu Pandey, Shashvat Sangle, Soumorup Chakrabarti",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "National Finalist in Inceptio 8.0 Marketing Challenge Competition, MPSTME NMIMS, Mumbai",
    date: "26 March 2025",
  },
  {
    id: 32,
    name: "Manaswi Rajput, Urja Saha, Ibrahim Ganijee, Rohan Pawar",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Winner in AlgoForge 25: Hackathon competition organized by KJ Somaiya Institute of Technology, Mumbai",
    date: "23 March 2025",
  },
  {
    id: 33,
    name: "Saloni Zargad, Kashish Suvarna, Vishakha Lade, Dishita Jain, Pragati More",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Secured 1st Position in Idea Presentation (Shark Tank) organized by Technical and Applied Chemistry Department, Veermata Jijabai Technological Institute, Mumbai",
    date: "22 March 2025",
  },
  {
    id: 34,
    name: "Muhammad Adil Bankar",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Secured 3rd position in CodeAstra Hackathon organized by Rajiv Gandhi Institute of Technology, Mumbai",
    date: "19 March 2025",
  },
  {
    id: 35,
    name: "Achintya Chavan, Harsh Chhallani",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Finalist (Top 11 in India) in EY Techathon 5.0 hackathon organized by EY - Ernst & Young, Bangalore",
    date: "17 March 2025",
  },
  {
    id: 36,
    name: "Himanshu Agrawal, Ganesh Kakade, Nakshatra Chandgothia",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Winners of Merge Mania: Case Study Competition organized by Sardar Patel Institute of Technology, Mumbai",
    date: "16 March 2025",
  },
  {
    id: 37,
    name: "Bhavik Desai, Abhigyan Jha, Gargi Dhulekar",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Winner of National Case Study: SPIT organized by SPIT ECell, Mumbai",
    date: "16 March 2025",
  },
  {
    id: 38,
    name: "Niraj Mahajan, Anurag Bagal, Shreerang Shukla, Kartik Rane",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Finalist of WCE Hackathon 2025 organized by Walchand College of Engineering (WCE), Sangli",
    date: "15 March 2025",
  },
  {
    id: 39,
    name: "Aditi Rao",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Finalist of Google Girl Hackathon organized by Google Inc., Bengaluru",
    date: "11 March 2025",
  },
  {
    id: 40,
    name: "Om Rane, Sudiksha Sawant, Tejas Prakash Rupwate",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "National Finalist of Ideathon 3.0 - National Level Conference for Ideation and Entrepreneurship with NSS organized by SNDT, Mumbai",
    date: "8 March 2025",
  },
  {
    id: 41,
    name: "Arushi Tiwari",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Winner of problem statement competition of Blossom, Bubbles & Bytes Women-Only Frontend Hackathon organized by WIE IEEE SPIT Mumbai",
    date: "8 March 2025",
  },
  {
    id: 42,
    name: "Pulkit Gupta, Aditi Rao",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Winners of Best Paper in the session of the 7th IEEE International Conference on Emerging Smart Computing & Informatics (ESCI-2025), sponsored by IEEE Pune chapter, IEEE Signal Processing Pune chapter and San Diego State University, organized by AISSMS Institute of Information Technology, Pune",
    date: "7 March 2025",
  },
  {
    id: 43,
    name: "Om Rane, Sudiksha Sawant, Sneha Jino",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "National Finalist in Bugbuster 2.0 National Level Hardware Hackathon organized by IETE SPIT, Mumbai",
    date: "23 February 2025",
  },
  {
    id: 44,
    name: "Ishaan Gawde, Anuj Gite, Vedanth Dhagay",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Secured 2nd position in Bugbuster 2.0 National Level Hardware Hackathon organized by IETE SPIT, Mumbai",
    date: "23 February 2025",
  },
  {
    id: 45,
    name: "Shweta Shinde, Uday Yeshi, Chinmay Thakur",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Winner of Bugbuster 2.0 National Level Hardware Hackathon organized by IETE SPIT, Mumbai",
    date: "23 February 2025",
  },
  {
    id: 46,
    name: "Arushi Tiwari, Hridaya Vashishtha, Abeer Sane",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Winner of Kaleidoscope 2025 - Case Study Competition organized by SIMS, Pune",
    date: "23 February 2025",
  },
  {
    id: 47,
    name: "Aparna Jha",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Winner of Cosmic Quest - The Ultimate Case Study Challenge competition organized by SPIT, Mumbai",
    date: "17 February 2025",
  },
  {
    id: 48,
    name: "Sudhanshu Pandey, Shashvat Sangle, Soumorup Chakrabarti, Shivam Singh",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "National Finalist in NES 2025: NIT Rourkela E-Summit Case Study Competition organized by NIT, Rourkela",
    date: "4 February 2025",
  },
  {
    id: 49,
    name: "Achintya Chavan, Harsh Chhallani",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Finalist of K! Hacks 2.0 hackathon organized by CEG, Anna University, Chennai",
    date: "1 February 2025",
  },
  {
    id: 50,
    name: "Bhavik Desai, Vishwaraj Sharma",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "National Finalist of Consultomania-Case Competition organized by SPJIMR, Mumbai",
    date: "26 January 2025",
  },
  {
    id: 51,
    name: "Bhavik Desai, Abhigyan Jha, Vinay Gupta",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "National Finalist of Finvisor-Case Study Competition organized by SPJIMR, Mumbai",
    date: "26 January 2025",
  },
  {
    id: 52,
    name: "Bhavik Desai, Vishwaraj Sharma",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "2nd Runner-up of Stock and Roll Valuation Case Study Competition organized by SPJIMR, Mumbai",
    date: "25 January 2025",
  },
  {
    id: 53,
    name: "Akshat Ambastha, Bhavik Desai, Anuj Gite",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Winners of Finanza'25 - Valuation Case Competition organized by IIM Lucknow",
    date: "7 January 2025",
  },
  {
    id: 54,
    name: "Suyog Repal",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Secured 3rd position in National Level Online Quiz competition organized by Department of Mathematics, Deogiri College Sambhajinagar",
    date: "22 December 2024",
  },
  {
    id: 55,
    name: "Sejal Kadam",
    class: "Ph.D",
    achievement: "Academics",
    awardDescription: "Finalists of 19th Aavishkar: Inter-Collegiate / Institute / Department Research Convention organized by Mumbai University",
    date: "15 December 2024",
  },
  {
    id: 56,
    name: "Tulshidas Mane",
    class: "Ph.D",
    achievement: "Academics",
    awardDescription: "Finalists of 19th Aavishkar: Inter-Collegiate / Institute / Department Research Convention organized by Mumbai University",
    date: "15 December 2024",
  },
  {
    id: 57,
    name: "Shrutika Yeole, Om Patil, Omkar Yadav, Ruchir Shukla, Pranav Shirole, Rushikesh Khedekar",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Winners of Smart India Hackathon organized by Ministry of Education, AICTE, New Delhi",
    date: "12 December 2024",
  },
  {
    id: 58,
    name: "Aparna Jha",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "1st runner up of Insight360: a National Level Media Case Study Competition organized by ISB&M, Pune",
    date: "24 November 2024",
  },
  {
    id: 59,
    name: "Bhavik Desai, Abhigyan Jha, Gargi Dhulekar, Harsh Gad",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "National Finalist of Eco-Lution: an International Case Competition organized by GIM, Goa",
    date: "17 November 2024",
  },
  {
    id: 60,
    name: "Himanshu Agrawal",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "1st Runner up of Eco-Lution: Your Ticket to The World of Management, International Case Competition organized by GIM, Goa",
    date: "16 November 2024",
  },
  {
    id: 61,
    name: "Aparna Jha",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "National Finalist of E-Conjecture: The Economics & Public Policy Event during Atharv Ranbhoomi'24 organized by IIM Indore",
    date: "10 November 2024",
  },
  {
    id: 62,
    name: "Akshat Ambastha, Anuj Gite",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Finalist of Quizonomics - Business Quiz organized by DoMS, IIT Madras",
    date: "10 November 2024",
  },
  {
    id: 63,
    name: "Akshat Ambastha, Anuj Gite",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Winners of Fynergy - A Finance Case Study competition organized by DoMS, IIT Madras",
    date: "10 November 2024",
  },
  {
    id: 64,
    name: "Akshat Ambastha",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Finalist of Business Panchatantra competition organized by DoMS, IIT Madras",
    date: "9 November 2024",
  },
  {
    id: 65,
    name: "Akshat Ambastha, Anuj Gite",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Secured 4th place in 1,2,3 Sold - Guess, Bid & Win Big competition organized by DoMS, IIT Madras",
    date: "9 November 2024",
  },
  {
    id: 66,
    name: "Mandar Dumbre, Aishwarya Bichave, Arya Patkar",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "1st place in the National Case Study Competition - MarkIIT, held at SAMANVAY'24, the annual business fest organized by the Department of Management Studies, IIT Madras",
    date: "9 November 2024",
  },
  {
    id: 67,
    name: "Akshat Ambastha",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Finalist of Vescase - Case Study competition organized by GGSIPU, Delhi",
    date: "25 October 2024",
  },
  {
    id: 68,
    name: "Smit Gawade, Eshaan Golatekar, Soham Gondhalekar",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "1st runner up of ISB business case study competition organized by ISB, Hyderabad",
    date: "19 October 2024",
  },
  {
    id: 69,
    name: "Om Patole, Ruturaj Parab, Aashi Hemnani",
    class: "T.Y",
    achievement: "Academic",
    awardDescription: "Winner of Business Case Study competition organized by Vivekanand Education Society's Institute of Management, Mumbai",
    date: "18 October 2024",
  },
  {
    id: 70,
    name: "Bhavik Desai, Vinay Gupta, Aarush Maheshwari",
    class: "S.Y",
    achievement: "Academic",
    awardDescription: "Finalist of Chocolate Factory 6.0: Construct your Choco-Dynasty! Competition organized by NMIMS, Mumbai",
    date: "11 October 2024",
  },
  {
    id: 71,
    name: "Keshav Jha, Manaswi Rajput, Prneeka Ballabh",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Selected as one of the winning entries in the VIVIBHA Vision for Viksit Bharat Research Paper Writing Competition (Konkan Prant Level) for the topic 'Skymapper: an antenna to track satellite from earth'",
    date: "8 October 2024",
  },
  {
    id: 72,
    name: "Aparna Jha",
    class: "S.E",
    achievement: "Academic",
    awardDescription: "Consolation prize winner of Sustainability Case Study event of Innovation for India organized by ICFAI Business School, Pune",
    date: "28 August 2024",
  },
  {
    id: 73,
    name: "Vedant Bhagwat, Omkar Lokre, Yash Ugale, Gandhar Kulkarni",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "2nd Runner up of National Case Study organized by E-Summit by E-Cell S.P.I.T.",
    date: "16 March 2024",
  },
  {
    id: 74,
    name: "Nidhish Dhadve",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "1st Runner up of Yashasvi - Make Your Mark - National Case Study competition organized by Symbiosis Centre for Management and Human Resource Development, Symbiosis Institute of Business Management, Pune",
    date: "14 March 2024",
  },
  {
    id: 75,
    name: "Mayuresh Pitale, Sridhar Sundar",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Finalist of UNPLUGGED 1.0 Hackathon organized by IETE-ISF DJSCE, Vile Parle",
    date: "9 March 2024",
  },
  {
    id: 76,
    name: "Gayatri Tajne",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "1st Runner up of DataDecode organized by IIT Delhi",
    date: "2 March 2024",
  },
  {
    id: 77,
    name: "Ayushi Naik, Gauri Narkar",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Winner of Consulting Challenge organized by MPSTME, NMIMS Mumbai",
    date: "27 February 2024",
  },
  {
    id: 78,
    name: "Pratham Gajapure, Henil Gandhi, Nishant Chandeliya",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Finalist of Resilient Routes - Sustainable Supply Chain Challenge organized by IIFM Bhopal",
    date: "24 February 2024",
  },
  {
    id: 79,
    name: "Pratham Gajapure, Henil Gandhi, Nishant Chandeliya",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Finalist of Marketing Mavericks organized by IIFM Bhopal",
    date: "24 February 2024",
  },
  {
    id: 80,
    name: "Nidhish Dhadve",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "2nd Runner up of Business Beacon organized by TECHFEST NMIMS, Mumbai",
    date: "17 February 2024",
  },
  {
    id: 81,
    name: "Malay Phadke",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Selected as MITACS Globalink Research Intern at University of Calgary, MITACS, Canada",
    date: "16 February 2024",
  },
  {
    id: 82,
    name: "Sejal Patil, Ayushi Naik, Aditi Ramugade",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Winner of Vishleshan: Annual Flagship Case Competition organized by VNIT Nagpur",
    date: "10 February 2024",
  },
  {
    id: 83,
    name: "Aryan Adav",
    class: "T.E",
    achievement: "Non-Academic",
    awardDescription: "Winner of Video Content Competition organized by Larana, Inc.",
    date: "5 February 2024",
  },
  {
    id: 84,
    name: "Vedant Bhagwat, Yash Surve, Damodar Kamath, Harsh Gad, Het Gala, Parth Jadhav, Atharva Kadge, Sahil Gupta, Piyanshu",
    class: "T.E",
    achievement: "Non-Academic",
    awardDescription: "Runner up of Intercollegiate Cricket organized by KJ Somaiya Vidyavihar, Mumbai",
    date: "24 January 2024",
  },
  {
    id: 85,
    name: "Nishant Chandeliya, Henil Gandhi, Nidhish Dhadve, Pratham Gajapure",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Second Runner up of Adomania: A Marketing Event organized by VJTI, Mumbai",
    date: "11 January 2024",
  },
  {
    id: 86,
    name: "Aniket Kesarwani, Advait Khaire, Govind Kela",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Semi Finalist of Amaethon: The Food & Agribusiness Conclave organized by IIM Ahmedabad",
    date: "23 December 2023",
  },
  {
    id: 87,
    name: "Nishant Chandeliya, Henil Gandhi, Nidhish Dhadve, Aniket Kesarwani",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "First Runner up of Breakthrough organized by Entrepreneurial Passion and Innovation Club (EPIC) of IIM Visakhapatnam",
    date: "11 December 2023",
  },
  {
    id: 88,
    name: "Nidhish Dhadve, Henil Gandhi, Nishant Chandeliya",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Winners of 'Cryptic Bonds' organized by GAEE IIFT Kakinada",
    date: "29 November 2023",
  },
  {
    id: 89,
    name: "Nidhish Dhadve, Henil Gandhi, Pratham Gajapure",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Finalists of Samriddhi (ECO-LUTION) organized by GIM (Goa Institute of Management)",
    date: "15 November 2023",
  },
  {
    id: 90,
    name: "Aditya Nagane",
    class: "S.E",
    achievement: "Academic",
    awardDescription: "Winner of Microapp event of Voltus Midspark23 organized by College of Engineering, Pune",
    date: "27 to 29 October 2023",
  },
  {
    id: 91,
    name: "Malay Phadke",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Winner of Kavach Hackathon organized by BPR&D, AICTE, I4C",
    date: "9 August 2023",
  },
  {
    id: 92,
    name: "Prathamesh Kulkarni",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Winner of Periperathon 1.0 conducted by AICTE SPICES SPIT, Mumbai",
    date: "5 July 2023",
  },
  {
    id: 93,
    name: "Anish Sambhare",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Runner up of the SPIT Innovation Cup -23 organized by AICTE SPICES, AICTE Idea-Lab SP-IT, SP-TBI, IEEE, ESA and IIC-S.P.I.T.",
    date: "8 April 2023 to 8 May 2023",
  },
  {
    id: 94,
    name: "Prathamesh Kulkarni",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Runner up of the SPIT Innovation Cup -23 organized by AICTE SPICES, AICTE Idea-Lab SP-IT, SP-TBI, IEEE, ESA and IIC-S.P.I.T.",
    date: "8 April 2023 to 8 May 2023",
  },
  {
    id: 95,
    name: "Esha Khot",
    class: "T.E",
    achievement: "Academic",
    awardDescription: "Patent granted on SYSTEM TO CONTROL VEHICULAR EMISSION AT TRAFFIC SIGNALS.",
    date: "21 April 2023",
  },
  {
    id: 96,
    name: "Anushka Anil Pilena",
    class: "B.E",
    achievement: "Academic",
    awardDescription: "Contribution in World Book of Record, India Book of Record, Asia Book of Record and Assist World Book of Record for Dr. APJ Abdul Kalam Satellite Launch Vehicle Mission 2023",
    date: "19 February 2023",
  },
  {
    id: 97,
    name: "Apoorva Limaye, Siddhant Kamlaskar, Varun Kamath",
    class: "B.E",
    achievement: "Academic",
    awardDescription: "Winners of 'The Inventors Challenge-2022' organized by Arm Education and STMicroelectronics with support from AICTE's Training and Learning Academy (ATAL), New Delhi",
    date: "5 December 2022",
  },
];

export default studentsData;
